import * as types from "../types";
import ReactGA from "react-ga";

export const gaFormAction = (action, label) => {
  ReactGA.event({
    category: "Form",
    action,
    label
  });
  return {
    type: types.GA_FORM_EVENT
  };
};

export const gaPageView = pageView => {
  ReactGA.pageview(pageView);
  return {
    type: types.GA_PAGE_VIEW
  };
};



// WEBPACK FOOTER //
// ./src/actions/GoogleAnalytics/googleAnalyticsActions.js